import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

const Header = ({ siteTitle, darkMode, onSetDarkMode }) => {

  const [ menuOpen, setMenuOpen ] = React.useState(false)

  return (
  <header
    className='bg-yellow-300 dark:bg-gray-800'
  >
    <div
      className='container mx-auto px-4 py-6 flex justify-between items-center'
    >
      <h1 className={`
        text-base
        md:text-xl
        m-0
      `}>
        <Link
          to="/"
          className='text-gray-700'
        >
          {siteTitle}
        </Link>
      </h1>
      <button type='button' className={`
          appearance-none
          outline-none
          cursor-pointer
          md:hidden
        `} onClick={() => setMenuOpen(!menuOpen)}><i className='material-icons'>menu</i></button>
      <div
        className={`
          ${ menuOpen ? 'block' : 'hidden' }
            md:flex
            md:gap-8
            absolute
            md:static
            bg-gray-200
            md:bg-transparent
            right-0
            left-0
            bottom-0
            top-20
            z-10
            p-4
            md:p-none
            text-center
        `}
      >
          <Link to='/' className={`hover:underline block`}>Home</Link>
          <Link to='/about' className={`hover:underline block`}>About</Link>
          <a className={`hover:underline block`} href='mailto:S2underground@protonmail.com?subject=Website%20Contact%20Form'>Email us!</a>

      </div>
    </div>
    
    {/* <button type='button' onClick={() => onSetDarkMode(!darkMode)} className={`
      w-10
      h-4
      rounded-full
      bg-gray-400
      relative
    `}><i className='material-icons text-white'>{ darkMode ? 'dark_mode' : 'light_mode' }</i></button> */}
  </header>
)
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
